import classNames from 'classnames';
import type { CSSProperties } from 'react';
import React from 'react';
import styles from './TableWidget.module.scss';

interface Props {
  noHeader?: boolean;
}

const columnLayoutStyle: CSSProperties = {
  gridTemplateColumns:
    'minmax(150px, 1.5fr) minmax(250px, 2.5fr) minmax(100px, 1.0fr) minmax(150px, 1.5fr) minmax(100px, 1.0fr)',
};

const TableWidgetLoading: React.FC<Props> = ({ noHeader }) => {
  return (
    <table
      className={classNames(styles.table, styles.readOnly, styles.loading, {
        [styles.noHeader]: noHeader,
      })}
    >
      <thead>
        <tr style={columnLayoutStyle}>
          {[...Array(5)].map((_, i) => (
            <th key={i}>
              <span className={styles.loadingPlaceholder} />
            </th>
          ))}
        </tr>
      </thead>
      <caption role="presentation" /* thead bottom border */ />
      <tbody>
        {[...Array(4)].map((_, i) => (
          <tr key={i} style={columnLayoutStyle}>
            {[...Array(5)].map((_, j) => (
              <td key={j}>
                <span className={styles.loadingPlaceholder} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableWidgetLoading;
